import { WorklistAttachmentType, WorklistData, WorklistReportType } from 'models/worklist';
import { BsCircleFill, BsFillDiamondFill, BsFillSquareFill, BsFillTriangleFill } from 'react-icons/bs';
import { IconType } from 'react-icons';
import { Priority, PriorityKeys } from 'models/rules';

export const containsAttachmentTypes = (props: { item?: WorklistData; types: WorklistAttachmentType[] }) => {
  const { item, types } = props;
  if (!item?.attachments?.measurementType) return false;
  return types.includes(item?.attachments?.measurementType) && !!item?.attachments?.measurementId;
};

export const containsBillingReportAttachment = (props: { item?: WorklistData }) => {
  const { item } = props;
  if (!item?.attachments?.reportType) return false; // If reportType is missing, we assume it's a summary report for backward compatibility with existing data
  return item.attachments.reportType === WorklistReportType.BillingReport;
};

export const containsReportAttachment = (props: { item?: WorklistData }) => {
  return !!props.item?.attachments?.reportId;
};

interface PriorityData {
  value: PriorityKeys;
  label: string;
  color: string;
  icon: IconType;
  filter: string;
  rotateIcon?: boolean;
}

export const PriorityMap: PriorityData[] = [
  {
    value: Priority.Critical,
    label: 'critical_label',
    color: 'var(--mantine-color-red-5)',
    icon: BsFillDiamondFill,
    filter: 'urgent',
  },
  {
    value: Priority.High,
    label: 'high_label',
    color: 'var(--mantine-color-peach-7)',
    icon: BsFillTriangleFill,
    filter: 'high',
  },
  {
    value: Priority.Medium,
    label: 'medium_label',
    color: 'var(--mantine-color-turquoise-5)',
    icon: BsCircleFill,
    filter: 'medium',
  },
  {
    value: Priority.Low,
    label: 'low_label',
    color: 'var(--mantine-color-blue-5)',
    icon: BsFillTriangleFill,
    filter: 'low',
    rotateIcon: true,
  },
];

export const getPriorityInfo = (priority?: PriorityKeys): PriorityData => {
  const priorityData = PriorityMap.find((p) => p.value === priority);

  if (priorityData) {
    return priorityData;
  }

  return {
    value: 0,
    label: 'unknown_label',
    icon: BsFillSquareFill,
    color: 'var(--mantine-color-gray-5)',
    filter: '',
  };
};
